import clsx from 'clsx';
import SliderContainer from './SliderContainer/SliderContainer';
import styles from './Slider.module.scss';
import { SlidesType } from './SliderCard/SliderCard';
import Button, { ButtonType } from '@/components/Button/Button';
import Text from '@/components/Text/Text';

type SliderSectionData = {
  title: string;
  description: string;
  slider: SlidesType[];
  subtitle?: string;
  button?: {
    id: number;
    link: string;
    title: string;
    type: ButtonType;
    iconName: string,
  };
};

const SliderSection = ({ data, children }: { data: SliderSectionData, children: React.ReactNode }) => (
  <div className={clsx(styles.sliderSection, 'custom')}>
    <div className={clsx(styles.content, 'global-section')}>
      <div className={styles.left}>
        <Text tag='h2'>
          {data.title}
        </Text>
        {data.subtitle && <p className={styles.subtitle}>{data.subtitle}</p>}
      </div>
      <div className={styles.right}>
        {data.description && <p>{data.description}</p>}
        {data?.button && (
          <Button
            type={data.button.type}
            fitContent
            href={data.button.link || ''}
            iconName={data.button.iconName}
          >
            {data.button.title}
          </Button>
        )}
      </div>
    </div>
    <SliderContainer>
      {children}
    </SliderContainer>
  </div>
);

export default SliderSection;
